import HriTheme from '../../../web/src/themes/HriTheme';
import SgaTheme from '../../../web/src/themes/SgaTheme';
export var themes = {
  hri: HriTheme,
  sga: SgaTheme
};